import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewLicenseServerInterface } from 'src/app/core/models/licenseServer';
import { LicenseServerService } from 'src/app/core/services/license-server.service';
import { AddLicenseServerComponent } from '../add-license-server/add-license-server.component';

@Component({
  selector: 'app-delete-license-server',
  templateUrl: './delete-license-server.component.html',
  styleUrls: ['./delete-license-server.component.scss']
})
export class DeleteLicenseServerComponent implements OnInit {

  constructor(public dialog: MatDialogRef<DeleteLicenseServerComponent>, 
    @Inject(MAT_DIALOG_DATA)
    public data: { licenseServerName?: string }) { }
  licenseServerName: string = this.data.licenseServerName;
  
  ngOnInit(): void {
  }

  onClose(){
    this.dialog.close(false);
  }

  onSubmit(){
    this.dialog.close(true);
  }

}
